<template>
  <div class="category">
    <router-link :to="{ name: r_name, params: { id: category.id } }">
      <div class="category__title">{{ category.title }}</div>
      <div class="category__count">
        {{ category.count + " " + companyText }}
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "CategoryChild",
  props: {
    category: {
      type: Object,
      required: true,
    },
    r_name: {
      default: "search",
      type: String,
    },
  },
  computed: {
    companyText() {
      if (this.category.count === 1) return this.$t("catalog.company");
      return this.$t("catalog.companies");
    },
  },
};
</script>
